var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHarnessViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9565 0H20.3478C21.2123 0 21.913 0.700772 21.913 1.56522V10.9565C21.913 11.821 21.2123 12.5217 20.3478 12.5217H10.9565C10.0921 12.5217 9.3913 11.821 9.3913 10.9565V1.56522C9.3913 0.700772 10.0921 0 10.9565 0ZM1.56522 23.4783H10.9565C11.821 23.4783 12.5217 24.179 12.5217 25.0435V34.4348C12.5217 35.2992 11.821 36 10.9565 36H1.56522C0.700772 36 0 35.2992 0 34.4348V25.0435C0 24.179 0.700772 23.4783 1.56522 23.4783ZM20.3478 23.4783H29.7391C30.6036 23.4783 31.3043 24.179 31.3043 25.0435V34.4348C31.3043 35.2992 30.6036 36 29.7391 36H20.3478C19.4834 36 18.7826 35.2992 18.7826 34.4348V25.0435C18.7826 24.179 19.4834 23.4783 20.3478 23.4783ZM18.2989 14.087H20.0489L24.7445 21.913H22.9946L18.2989 14.087ZM13.0054 14.087L8.30976 21.913H6.55979L11.2554 14.087H13.0054Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarnessViewIcon);
export default __webpack_public_path__ + "static/media/harness-view-icon.1d8458786c6a53dbd9a27e6b71de7971.svg";
export { ForwardRef as ReactComponent };